import { useQuery } from '@apollo/client'
import { gql } from '~/__generated__'

export const GET_CURRENT_USER_QUERY = gql(`
  query getCurrentUser {
    currentUser {
      id
    }
  }
`)

export const useCurrentUser = () => {
  const { data, loading } = useQuery(GET_CURRENT_USER_QUERY)

  return {
    currentUser: data?.currentUser,
    loading,
  }
}
